import { memo } from 'react';
import loadable from '@utils/loadable';

import withMetatag from '../../decorators/metadataDecorators/metatagsTitleDecorator';

const LearnMore = loadable(() => import('../../components/LandingPages/LearnMoreComponents/MainLearnMore'));

const styles = {
  position: 'relative',
  maxWidth: 1920,
  margin: 'auto',
  zIndex: 10,
  width: '100%',
};

const wrapperStyle = {
  backgroundColor: '#FFFFFF',
};

export const LearnMoreLayout = ({ isWatchlists, piwikEnabled }) => (
  <div style={wrapperStyle}>
    <div style={styles}>
      <LearnMore
        piwikEnabled={piwikEnabled}
        isWatchlists={isWatchlists}
      />
    </div>
  </div>
);

export default withMetatag(memo(LearnMoreLayout), '/learn-more');
